import PropTypes from 'prop-types';

import { CustomReportTypes } from './constants';

const customReportTypePropTypes = PropTypes.oneOf([CustomReportTypes.REPORT, CustomReportTypes.REPORT_SET]).isRequired;

const queryParamValuePropType = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number,
  PropTypes.bool,
]);

const reportSetIdPropType = PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired;

export const paramPropType = PropTypes.shape({
  mappingName: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  query: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string,
  id: PropTypes.string,
});

const customReportParamsPropType = PropTypes.objectOf(
  PropTypes.shape({
    mappingName: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
    query: PropTypes.string,
    value: PropTypes.string,
    label: PropTypes.string,
    id: PropTypes.string,
  })
);

export const customReportQueryPropTypes = PropTypes.shape({
  columns: PropTypes.arrayOf(PropTypes.string.isRequired),
  customReportFlag: PropTypes.bool.isRequired,
  customReportType: customReportTypePropTypes,
  queryParams: PropTypes.objectOf(queryParamValuePropType),
  reportSetId: reportSetIdPropType,
  reportSetName: PropTypes.string.isRequired,
  params: customReportParamsPropType,
  rows: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.objectOf(PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool,
      ])),
      PropTypes.string,
    ])
  ).isRequired,
  sql: PropTypes.string.isRequired,
  serverSide: PropTypes.bool,
  defaultOrderBy: PropTypes.string,
});

export const customReportSetPropTypes = PropTypes.shape({
  customReportFlag: PropTypes.bool.isRequired,
  customReportType: customReportTypePropTypes,
  reports: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
  ).isRequired,
  reportSetId: reportSetIdPropType,
  reportSetName: PropTypes.string.isRequired,
});

export const customReportPropTypes = PropTypes.oneOfType([
  customReportQueryPropTypes,
  customReportSetPropTypes,
]);

export const customReportsPropTypes = PropTypes.arrayOf(customReportPropTypes).isRequired;

const reportDataCellPropType = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number,
  PropTypes.bool,
]);

const reportDataRowPropType = PropTypes.objectOf(reportDataCellPropType);

const reportDataRowsPropType = PropTypes.oneOfType([
  PropTypes.arrayOf(reportDataRowPropType),
  PropTypes.objectOf(reportDataCellPropType),
]).isRequired;

const reportDataTypesPropType = PropTypes.objectOf(
  PropTypes.oneOfType([PropTypes.number, PropTypes.string])
).isRequired;

const singleCustomReportDataShape = PropTypes.shape({
  columns: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
  rows: reportDataRowsPropType,
  name: PropTypes.string.isRequired,
  types: reportDataTypesPropType,
  customReportType: PropTypes.oneOf([CustomReportTypes.REPORT]).isRequired,
});

const reportSetSubReportDataShape = PropTypes.shape({
  columns: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
  rows: reportDataRowsPropType,
  name: PropTypes.string.isRequired,
  types: reportDataTypesPropType,
  pillName: PropTypes.string,
});

export const customReportDataPropTypes = PropTypes.oneOfType([
  singleCustomReportDataShape,
  PropTypes.shape({
    reports: PropTypes.arrayOf(reportSetSubReportDataShape.isRequired).isRequired,
    name: PropTypes.string.isRequired,
    customReportType: PropTypes.oneOf([CustomReportTypes.REPORT_SET]).isRequired,
  }),
]);
